import { render } from "./BottomLinks.vue?vue&type=template&id=393f792b"
import script from "./BottomLinks.vue?vue&type=script&lang=js"
export * from "./BottomLinks.vue?vue&type=script&lang=js"

import "./BottomLinks.vue?vue&type=style&index=0&id=393f792b&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__